import { Box, Grid } from '@mui/material'
import React, { useState } from 'react'
import DropDownV3 from '../../../../common/DropDownV3'
import TextBox from '../../../../common/TextBox'
import { navigation1, useDebouncedHandler } from '../../../../utils/helpers'
import { useDispatch } from 'react-redux'
import { showErrorAlert } from '../../../../redux/Actions'
import { getGSTValidation } from '../../../../redux/Booking/BookingActions'
import GSTModal from '../../../modal/GSTModal'
import VerifiedIcon from '@mui/icons-material/Verified';
const BkgType = (props) => {
  const { bkgDeatails, setBkgDetails, filterOpt = {}, tableData = [], setFilterOpt = {} } = props
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState({
    id: 0,
    open: false,
    data: {}
  });
  const typeProps = () => {
    return {
      width: "100%",
      name: "type",
      id: 'bkgtype',
      label: "Type",
      isCompulsory: false,
      options: filterOpt?.bkgType || [],
      preSelectedValues: bkgDeatails?.bkgType || [],
      searchPlaceholder: "Search by Type",
      disabled: false,
      isObject: true,
      primaryKey: 'id',
      labelKey: 'label',
      singleSelect: true,
      selectAllOption: false,
      defaultAllSelected: false,
      nextId: 'phoneNumber',
      prevId: `trip-${tableData.length - 1}`,
    }
  }
  
  const handleBkyType = (val) => {

    let paymentModeList = []
    if (val?.[0]?.id === "AP") {
      paymentModeList.push(
        {
          label: "Cash",
          key: "Cash",
          id: 1
        })
    } else {
      paymentModeList.push(...filterOpt?.allPaymentMode)
    }
    setBkgDetails((prev) => ({
      ...prev,
      bkgType: val,
      paymentMode: paymentModeList.length > 0 ? [paymentModeList[0]] : []
    }))
    setFilterOpt((prev) => ({
      ...prev,
      paymentMode: paymentModeList
    }))
  }
  const handleInputField = (event) => {
    if (event.target.name === 'phoneNumber') {
      localStorage.setItem('BBTPhoneNumber', event.target.value)
    }
    setBkgDetails((prev) => ({
      ...prev,
      [event.target.name]: event.target.value
    }))
  }
  const handleVerifyGST = () => {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    setBkgDetails((prev) => ({
      ...prev,
      verfiyGst: false
    }))
    if (bkgDeatails?.gstNo?.trim() === '') {
      dispatch(showErrorAlert('Enter GST Number'))
    } else if (!gstRegex.test(bkgDeatails?.gstNo)) {
      dispatch(showErrorAlert('Invalid GST Number'))
    } else {
      const params = {
        GSTN: bkgDeatails.gstNo,
      };
      dispatch(getGSTValidation('https://cargoapi.mavenconnect.tech/api/Common/GSTNValidation', params)).then((response) => {
        if (response?.status === 'True') {
          let gstData = response?.Data?.[0] || {}
          if (gstData.Status === 'Active') {
            setOpenModal((prev) => ({
              ...prev,
              id: 1,
              open: true,
              data: { ...gstData, GSTN: bkgDeatails.gstNo }
            }))
            setBkgDetails((prev) => ({
              ...prev,
              verfiyGst: true
            }))
          } else {
            dispatch(showErrorAlert('GST Number is not Active', 'gstNo'))
          }
        } else {
          dispatch(showErrorAlert(response?.ErrMessage || 'GST Verification Failed', 'gstNo'))
        }
      })
    }

  }
  const debouncedInputField = useDebouncedHandler(handleInputField, 500);
  return (
    <>
      <Box className='BkgType_page'>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          flexWrap={'wrap'}
          alignItems="stretch"
          sx={{ padding: '0px' }}
          columnSpacing={{ xs: '8px' }}
          rowSpacing={{ xs: '12px' }}
        >
          <Grid item size={2} className='smallDropDownp28'>
            <DropDownV3
              {...typeProps()}
              onSelect={handleBkyType}
            />
          </Grid>
          <Grid item size={2} className='smallTextBox28'>
            <TextBox label='Phone Number' type='number' id='phoneNumber' name='phoneNumber' maxLength={10} value={bkgDeatails?.phoneNumber} onChange={debouncedInputField}
              onKeyDown={(event) => {
                if (event.key === 'Enter' && event.target.value?.toString().trim() === '') {
                  dispatch(showErrorAlert('Enter Phone Number', `phoneNumber`))
                } else if (event.key === 'Enter' && event.target.value?.toString()?.trim().length !== 10) {
                  dispatch(showErrorAlert('Invalid Mobile No', `phoneNumber`))
                } else {
                  navigation1(event, 'email', 'bkgtype')
                }
              }}
            />
          </Grid>
          <Grid item size={3} className='smallTextBox28'>
            <TextBox label='Email ID' type='text' name='email' id='email' value={bkgDeatails?.email} onChange={debouncedInputField}
              onKeyDown={(event) => {
                navigation1(event, bkgDeatails?.bkgType?.[0]?.id === "AP" ? !(bkgDeatails?.roleRight?.AllowAutoCancelMinChange === 1) ? `SeatLabel-0` : 'autoCancelMins' : `manualTicketNo`, 'phoneNumber')
              }}
            />
          </Grid>

          <Grid item size={3} className='smallTextBox28 gstverficationInput'>
            <TextBox label='GSTN' type='text' name='gstNo' id='gstNo' value={bkgDeatails?.gstNo} onChange={(event) => {
              debouncedInputField(event);
              setBkgDetails((prev) => ({
                ...prev,
                verfiyGst: false
              }))
            }} />
            {bkgDeatails?.verfiyGst ?
              <Box className='verifiedIcon'>
                <VerifiedIcon />
              </Box>
              : <Box className='verifyBtn' onClick={handleVerifyGST}>Verify</Box>
            }
          </Grid>
          {bkgDeatails?.bkgType?.[0]?.id === "AP" ?
            <Grid item size={2} className='smallTextBox28'>
              <TextBox label='AutoCancel (Mins)' type='number'
                onKeyDown={(event) => {
                  navigation1(event, `SeatLabel-0`, 'email')
                }}
                disabled={!(bkgDeatails?.roleRight?.AllowAutoCancelMinChange === 1)} id='autoCancelMins' name='autoCancelMins' value={bkgDeatails?.autoCancelMins} onChange={debouncedInputField} />
            </Grid>
            :
            <Grid item size={2} className='smallTextBox28'>
              <TextBox label='Manual Ticket No' type='text'
                regePattern={`^[a-zA-Z0-9 ]*$`} isSpecficText={true}
                onKeyDown={(event) => {
                  navigation1(event, `SeatLabel-0`, 'email')
                }}
                maxLength={10}
                id='manualTicketNo' name='manualTicketNo' value={bkgDeatails?.manualTicketNo} onChange={debouncedInputField} />
            </Grid>
          }
        </Grid>
      </Box>
      {openModal.open && (
        <GSTModal
          open={openModal.open && openModal.id === 1}
          data={openModal.data}
          titleText="GST Details"
          onClose={() => setOpenModal({ id: 0, open: false, data: {} })}
        />
      )}
    </>

  )
}

export default BkgType